import React from 'react'

const SchemaStars = (props) => {
    const reviews = props.reviews || false;
    const calculated = props.calculated;
    let total = reviews.length;

    const calculateRate = (rates) => {
        if (rates === undefined) return false;

        let sum = 0;
        total = rates.length
        const len = rates.length

        rates.map(rate => {
            sum += (rate * 1)
            return true
        })

        return Math.ceil(sum / len);
    }

    const Stars = ({ rate }) => {
        let stars = [];
        if (!calculated) {
            if (props.calculate) rate = calculateRate(props.calculate)

            for (let index = 1; index <= 5; index++) {
                let rated = (5 * rate / 100) + ''
                rated = rated.split('.')

                let decimal = rated[1] !== undefined ? rated[1].substring(0, 1) : false
                let width = '0%'

                if (rated[0] * 1 >= index) width = '100%'
                if (decimal !== false && (rated[0] * 1 - index) === -1) width = decimal + '0%'

                const style = {
                    width: width
                }

                stars.push(
                    <div key={index} className={!props.page ? "starbg" : `starbg-${props.page}`}>
                        <div style={style} className={!props.page ? "star on" : `star-${props.page} on`}></div>
                    </div>
                )
            }
        } else {
            let finished = false;
            for (let index = 1; index <= 5; index++) {
                const style = {
                    width: "0%"
                }
                if (!finished) {
                    if (index <= calculated) {
                        style.width = "100%"
                    } else {
                        let decimal = calculated - Math.floor(calculated);
                        let porcentage = decimal * 100;
                        style.width = porcentage + "%"
                        finished = true;
                    }
                }
                stars.push(
                    <div key={index} className={!props.page ? "starbg" : `starbg-${props.page}`}>
                        <div style={style} className={!props.page ? "star on" : `star-${props.page} on`}></div>
                    </div>
                )
            }
        }
        return stars;
    }

    const RateNum = (rate) => {
        if (props.calculate) rate = calculateRate(props.calculate)
        return ((rate / 20).toFixed(1))
    }

    const Render = () => {
        if (!calculated) {
            if (props.calculate && !calculateRate(props.calculate)) return <></>
        }

        return (
            <div className="rating">
                <div className="number">{calculated ? calculated : RateNum(props.rate || 0)}</div>
                <div className="stars">
                    <Stars rate={props.rate || 0} />
                </div>
                {reviews && <div className="reviews"><p onClick={scrollTo}>( <span >{typeof props.reviews === 'boolean' ? total : props.reviews}</span> review{total > 1 ? 's' : ''} )</p></div>}
            </div>
        )
    }

    const scrollTo = () => {
        if (props.url) {
            window.location.href = props.url;
        } else {
            const violation = document.getElementsByName("reviews");
            window.scrollTo({
                top: violation[0].offsetTop - 150,
                behavior: "smooth"
            });
        }

    };

    return (
        <Render />
    )
}

export default SchemaStars